/**
 * Retrieve the current category name by the URL.
 * We extract the category name from the next slice right after "/collections".
 *
 * @param currentUrlPathname - The current URL pathname. Should always be: window.location.pathname.
 * @returns The current category name.
 */
export const getCurrentCategory = (
  currentUrlPathname: string,
): string | undefined => {
  const category = currentUrlPathname.split('/collections/')[1]

  return category
}
